import { axiosInstance } from ".";
import {
  AddFeedback360Request,
  CreateFeedback360Request,
  Feedback360Response,
  Feedback360Summary,
} from "../pages/private/myArea/menus/assessments/360Feedback/types";
import { Feedback360SubmitData } from "../pages/public/PublicFeedback360";

export async function getFeedback360Requests(): Promise<Feedback360Response[]> {
  return (await axiosInstance.get("/feedback360")).data;
}

export async function getFeedback360Result(): Promise<Feedback360Summary | null> {
  return (await axiosInstance.get("/feedback360/result")).data;
}

export async function createFeedback360Requests(
  request: CreateFeedback360Request
): Promise<any> {
  return (await axiosInstance.post("/feedback360", request)).data;
}

export async function addMoreFeedback360Requests(
  request: AddFeedback360Request
): Promise<any> {
  return (await axiosInstance.put("/feedback360", request)).data;
}

export async function fetch360Feedback(
  uuid: string
): Promise<any> {
  return (await axiosInstance.get(`/feedback360/validate/${uuid}`)).data;
}

export async function submitFeedback(
  data: Feedback360SubmitData
): Promise<any> {
  return (await axiosInstance.post("/feedback360/submit", data)).data;
}
